
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ExecutionResult, RequisitionApprovalContext, RequisitionApprovalResult, RequisitionApprovalsContext, RequisitionApprovalsResponse } from "@tylertech/tyler-api-types";

/**
 * RequisitionApprovalService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class RequisitionApprovalService {
    constructor(private readonly $apiService: ApiService) { }
    
    CanUserApproveRequisitions(pContext: RequisitionApprovalsContext): Promise<ExecutionResult<RequisitionApprovalsResponse>> {
        return this.$apiService.sendAuth("IRequisitionApprovalService/CanUserApproveRequisitions", pContext);
    }
    SaveRequisitionApprovals(pContext: RequisitionApprovalContext): Promise<ExecutionResult<RequisitionApprovalResult>> {
        return this.$apiService.sendAuth("IRequisitionApprovalService/SaveRequisitionApprovals", pContext);
    }
}
